/// <amd-module name="Feed/Legacy/Components/WrappedGlobalSettingsPanel" />
import * as React from "react";
import { connect } from "react-redux";

import { WrappedComponent } from "VSS/Platform/Layout";

import { IFeedHubViewState, showGlobalSettingsPanel } from "Feed/Core/Redux/FeedHub";

interface IGlobalSettingsPanelProps {
    show: boolean;
}

/**
 * Dynamically loads the feed-admin bundle and instantiates the global settings panel component
 */
class GlobalSettingsPanel extends React.Component<IGlobalSettingsPanelProps> {
    public render() {
        const show = this.props.show;
        return (
            show && (
                <WrappedComponent
                    dependencies={["ms.feed.feed-admin"]}
                    wrappedType="ms.feed.feed-admin.global-settings-panel"
                />
            )
        );
    }
}

function mapStateToProps(state: IFeedHubViewState): IGlobalSettingsPanelProps {
    return {
        show: showGlobalSettingsPanel(state)
    };
}

export const WrappedGlobalSettingsPanel = connect(mapStateToProps)(GlobalSettingsPanel);
